var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2.25C5.27208 2.25 2.25 5.27208 2.25 9C2.25 12.7279 5.27208 15.75 9 15.75C12.7279 15.75 15.75 12.7279 15.75 9C15.75 5.27208 12.7279 2.25 9 2.25ZM0.75 9C0.75 4.44365 4.44365 0.75 9 0.75C13.5563 0.75 17.25 4.44365 17.25 9C17.25 13.5563 13.5563 17.25 9 17.25C4.44365 17.25 0.75 13.5563 0.75 9Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.19359 6.01824C8.84445 5.95835 8.48538 6.02396 8.17998 6.20345C7.87458 6.38294 7.64255 6.66472 7.525 6.99888C7.38755 7.38963 6.95936 7.59495 6.56862 7.4575C6.17788 7.32005 5.97255 6.89186 6.11 6.50112C6.3451 5.83279 6.80915 5.26922 7.41995 4.91025C8.03076 4.55128 8.74889 4.42006 9.44718 4.53983C10.1455 4.6596 10.7788 5.02264 11.2351 5.56465C11.6912 6.10654 11.941 6.79236 11.94 7.50069C11.9398 8.30331 11.5177 8.91677 11.0813 9.33481C10.6448 9.753 10.1273 10.0432 9.76191 10.2182C9.73272 10.2322 9.71152 10.2522 9.69977 10.2695C9.6943 10.2775 9.69186 10.2834 9.69085 10.2866C9.68998 10.2893 9.69 10.2904 9.69 10.2906V10.5C9.69 10.9142 9.35421 11.25 8.94 11.25C8.52579 11.25 8.19 10.9142 8.19 10.5V10.2906C8.19 9.63821 8.60142 9.11092 9.11386 8.86543C9.41119 8.72299 9.76971 8.51412 10.0436 8.2517C10.3175 7.98925 10.44 7.74078 10.44 7.5V7.49888C10.4405 7.14464 10.3157 6.80165 10.0875 6.53065C9.85941 6.25964 9.54273 6.07813 9.19359 6.01824Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 12.75C9.75 13.1642 9.41421 13.5 9 13.5C8.58579 13.5 8.25 13.1642 8.25 12.75C8.25 12.3358 8.58579 12 9 12C9.41421 12 9.75 12.3358 9.75 12.75Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCircle);
export default __webpack_public_path__ + "static/media/help-circle.bc9378a257412a053fd873e3194b46a7.svg";
export { ForwardRef as ReactComponent };